import { render, staticRenderFns } from "./IncidentTable.vue?vue&type=template&id=9857c2f4&scoped=true"
import script from "./IncidentTable.vue?vue&type=script&lang=js"
export * from "./IncidentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9857c2f4",
  null
  
)

export default component.exports